import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { readEnvVar } from '../../env.runtime.js';

export function ForgotPasswordRedirect() {
  const idpBase = readEnvVar('VITE_IDP_BASE_URL') || '';
  const target = idpBase ? `${idpBase.replace(/\/$/, '')}/forgot-password` : undefined;
  useEffect(() => {
    if (target) window.location.assign(target);
  }, [target]);
  return target ? (
    <div>Redirecting to password recovery…</div>
  ) : (
    <div>Forgot password is not configured. Set VITE_IDP_BASE_URL.</div>
  );
}

export function ResetPasswordRedirect() {
  const { token } = useParams();
  const idpBase = readEnvVar('VITE_IDP_BASE_URL') || '';
  const base = idpBase ? `${idpBase.replace(/\/$/, '')}/reset-password` : undefined;
  const target = base ? `${base.replace(/\/$/, '')}/${token ?? ''}` : undefined;
  useEffect(() => {
    if (target) window.location.assign(target);
  }, [target]);
  return target ? (
    <div>Redirecting to password reset…</div>
  ) : (
    <div>Reset password is not configured. Set VITE_IDP_BASE_URL.</div>
  );
}
